import type { User } from '../types'

/**
 * A server timestamp as an instant. The backend stores naive UTC and sends it
 * without a zone ("2026-10-09T04:48:50.962295"), which `new Date` would read as
 * local time — hours off either way, so a trial could look open after the
 * server has closed it. A string that does carry a zone is read as given.
 */
function serverInstant(value: string): Date {
  return new Date(/(Z|[+-]\d{2}:?\d{2})$/i.test(value) ? value : `${value}Z`)
}

/**
 * Mirror of the backend `require_pro_plan` check (dependencies.py): a user has
 * Pro access if their plan is "pro" with a non-expired plan_expires_at, OR
 * their trial window is still open. Used to decide UI affordances such as
 * Pro-only CTAs and feature gates.
 */
export function isProOrTrial(user: User | null | undefined): boolean {
  if (!user) return false
  const now = new Date()
  if (user.plan === 'pro') {
    if (!user.plan_expires_at) return true
    if (serverInstant(user.plan_expires_at) > now) return true
  }
  if (user.trial_ends_at && serverInstant(user.trial_ends_at) > now) return true
  return false
}
